// src/utils/SimpleAudioManager.js
// A simple manager for caching and playing game audio files

const SimpleAudioManager = {
  // Audio cache
  _audioCache: {},
  
  // Load and cache an audio file
  preloadAudio: function(id, src) {
    return new Promise((resolve, reject) => {
      // Check if already cached
      if (this._audioCache[id]) {
        resolve(this._audioCache[id]);
        return;
      }
      
      // Create a new Audio object
      const audio = new Audio();
      
      // Set up event handlers
      audio.addEventListener('canplaythrough', () => {
        // Store in cache
        this._audioCache[id] = audio;
        resolve(audio);
      }, { once: true });
      
      audio.addEventListener('error', (err) => {
        console.error(`Failed to load audio: ${id} from ${src}`, err);
        reject(err);
      });
      
      // Start loading
      audio.src = src;
      audio.load();
    });
  },
  
  // Get an audio object (create if needed)
  getAudio: function(id) {
    return this._audioCache[id] || null;
  },
  
  // Play an audio track
  play: function(id, options = {}) {
    const audio = this.getAudio(id);
    
    if (!audio) {
      console.warn(`Audio not found: ${id}`);
      return null;
    }
    
    // Apply options
    if (options.loop !== undefined) audio.loop = options.loop;
    if (options.volume !== undefined) audio.volume = options.volume;
    
    // Reset if it was already playing
    audio.currentTime = 0;
    
    // Play the audio
    audio.play().catch(e => {
      console.warn(`Error playing audio ${id}:`, e);
    });
    
    return audio;
  },
  
  // Stop audio playback
  stop: function(id) {
    const audio = this.getAudio(id);
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
  },
  
  // Pause audio playback
  pause: function(id) {
    const audio = this.getAudio(id);
    if (audio) {
      audio.pause();
    }
  },
  
  // Resume audio playback
  resume: function(id) {
    const audio = this.getAudio(id);
    if (audio && audio.paused) {
      audio.play().catch(e => {
        console.warn(`Error resuming audio ${id}:`, e);
      });
    }
  }
};

export default SimpleAudioManager;